<div *ngIf="title && title.length > 0" [ngClass]="classNames" role="tooltip" #tooltip>
    <div class="tooltip-arrow"></div>
    <div class="tooltip-inner">{{title}}</div>
</div>